module.exports = __webpack_public_path__ + "static/media/scroll5.493299a6.png";